"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Group = void 0;
var _react = _interopRequireWildcard(require("react"));
var _flattenAndJoinNodes = require("@cbhq/cds-common/utils/flattenAndJoinNodes");
var _Box = require("./Box");
var _Spacer = require("./Spacer");
const _excluded = ["className"],
  _excluded2 = ["children", "direction", "divider", "gap", "renderItem"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const ItemWrapper = /*#__PURE__*/(0, _react.memo)(_ref => {
  let className = _ref.className,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_Box.Box, _extends({
    display: "contents"
  }, props));
});
const fallbackRenderItem = ({
  item,
  index
}) => {
  return /*#__PURE__*/_react.default.createElement(ItemWrapper, {
    key: index
  }, item);
};
const Group = /*#__PURE__*/(0, _react.memo)( /*#__PURE__*/(0, _react.forwardRef)((_ref2, forwardedRef) => {
  let children = _ref2.children,
    _ref2$direction = _ref2.direction,
    direction = _ref2$direction === void 0 ? 'vertical' : _ref2$direction,
    divider = _ref2.divider,
    gap = _ref2.gap,
    _ref2$renderItem = _ref2.renderItem,
    renderItem = _ref2$renderItem === void 0 ? fallbackRenderItem : _ref2$renderItem,
    boxProps = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  // TODO: Remove once `horizontal` is sunset in Q2.
  const contents = (0, _react.useMemo)(() => (0, _flattenAndJoinNodes.flattenAndJoinNodes)({
    children,
    gap,
    divider,
    renderItem,
    direction,
    Spacer: _Spacer.Spacer,
    ItemWrapper
  }), [children, direction, divider, gap, renderItem]);
  return /*#__PURE__*/_react.default.createElement(_Box.Box, _extends({
    ref: forwardedRef,
    alignItems: "stretch",
    flexDirection: direction === 'horizontal' ? 'row' : 'column',
    flexWrap: "nowrap",
    role: "group"
  }, boxProps), contents);
}));
exports.Group = Group;
Group.displayName = 'Group';